(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("ijKQm", function(module, exports) {
const $d55e567b2834d99c$var$passwords = document.querySelectorAll(".f-text.--password");
$d55e567b2834d99c$var$passwords.forEach((password)=>{
    const toggle = password.querySelector(".f-text__toggle");
    const input = password.querySelector(".f-text__input[type='password']");
    if (!input) return;
    toggle?.addEventListener("click", ()=>{
        toggle.classList.toggle("--active");
        input.type = input.type === "password" ? "text" : "password";
    });
});

});

})();
//# sourceMappingURL=text-field--password.834b6f71.js.map
